import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { useHeadingContext } from '../Heading.Context/index.es.js';

const HeadingEyebrow = ({ children, ...rest })=>{
    const { size, type } = useHeadingContext();
    return jsx("span", {
        className: classNames('cb-heading-eyebrow', size, type),
        ...rest,
        children: jsx("span", {
            children: children
        })
    });
};
HeadingEyebrow.displayName = 'Heading.Eyebrow';

export { HeadingEyebrow };
//# sourceMappingURL=Heading.Eyebrow.es.js.map
